import { GetPageQuery } from "apollo"
import { getUmbracoMediaUrl } from "."
import { extractProperty } from "./extractProperty"

export type MetaData = {
  pageSlug: string | undefined
  metaTitle: string | undefined
  metaKeywords: string | undefined
  metaDescription: string | undefined
  robotsTxt: string | undefined
  canonicalUrl: string | undefined
  oldUrls: string[]
  jsonPdSchema: string | undefined
}
export type Category = {
  metaData: MetaData
}

export function getMataTag(object: any) {
  return {
    pageSlug: extractProperty(object, "pageslug") as string | undefined,
    metaTitle: extractProperty(object, "metaTitle") as string | undefined,
    metaKeywords: extractProperty(object, "metaKeywords") as string | undefined,
    metaDescription: extractProperty(object, "metaDescription") as string | undefined,
    robotsTxt:
      (extractProperty(object, "robotsTxt") as string | undefined) ||
      process.env.ENV?.includes("production")
        ? {
            index: true,
            follow: true,
          }
        : {
            index: false,
            follow: false,
          },
    canonicalUrl: extractProperty(object, "canonicalUrl") as string | undefined,
    oldUrls: extractProperty(object, "oldUrls") as string[],
    titleBreadcrumbs: extractProperty(object, "titleBreadcrumbs") as string | undefined,
    ogImage: getUmbracoMediaUrl(extractProperty(object, "ogImageSHARE") as string | undefined),
    jsonPdSchema: extractProperty(object, "jsonPdSchema") as string | undefined,
  }
}
type Props = {
  itemsData: GetPageQuery
  infoBlock?: boolean
}
export function extractMetaTags({ itemsData }: Props) {
  let object = itemsData.page

  const pageBlock = extractProperty(object, "pageInfoAndMetaTags")
  const pageInfo = extractProperty(object, "pageInfoBlockContent")
  if (pageBlock) {
    object = pageBlock?.[0]
  } else if (pageInfo) {
    object = pageInfo?.[0]
  } else {
    // Try to extract from innerPageInfo structure
    const innerPageInfo = object // This is your innerPageInfo object
    // Extract the pageInfoAndMetaTags property from innerPageInfo
    const pageInfoAndMetaTags = extractProperty(innerPageInfo, "pageInfoAndMetaTags")

    if (pageInfoAndMetaTags) {
      // Handle case where pageInfoAndMetaTags is an array of blocks
      if (Array.isArray(pageInfoAndMetaTags)) {
        object = pageInfoAndMetaTags[0]
      } else {
        object = pageInfoAndMetaTags
      }
    }
  }
  // console.log("Final object for metaData extraction:", object)
  const metaData = getMataTag(object)
  return metaData
}
